import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatFormFieldModule} from '@angular/material/form-field';
import { ToastService } from '../../@services/toast.service';
import { ClientNotificationsService } from '../../@services/client-notifications.service';
import { UsersService } from '../../@services/users.service';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-client-notifications',
  imports: [CommonModule, FormsModule, MatButtonModule, MatFormFieldModule, MatSelectModule, MatInputModule],
  templateUrl: './client-notifications.component.html',
  styleUrl: './client-notifications.component.scss'
})
export class ClientNotificationsComponent implements OnInit, OnDestroy {

  private subs: any = [];
  notifications: any[] = [];
  clients: any[] = [];
  new_notification: any = {
    Client: '',
    Type: 'info', //Hardcoded for now, support selecting type later if needed
    Message: '',
    CreatedAt: '',
  }

  constructor(
    public notifyService: ClientNotificationsService,
    private toast: ToastService,
    private usersService: UsersService
  ) {
    let dt = DateTime.now().setZone('America/New_York');
    this.new_notification.CreatedAt = dt.toFormat('MMMM dd, yyyy');
  }

  ngOnInit(): void {
    this.subs = [
      this.notifyService.notifications.subscribe((res: any) => {
        if (res?.err) {
          this.notifications = [];
          return;
        }
        this.notifications = res;
      }),
    ];

    this.notifyService.getNotifications();

    this.get_clients();
  }
  ngOnDestroy(): void {
    if (this.subs?.length) {
      this.subs.forEach((sub: any) => {
        sub.unsubscribe();
      });
    }
  }

  async get_clients() {
    let res = await this.usersService.getCustomers();
    if (!res.err) {
      this.clients = res;
      this.clients.unshift('all');
    }
  }

  add_notification_enabled() {
    return this.new_notification.Client && this.new_notification.Type && this.new_notification.Message;
  }

  async add_notification() {
    let res = await this.notifyService.addNotification(this.new_notification);
    if (res && !res.err) {
      this.new_notification = {
        Client: '',
        Type: 'info',
        Message: '',
        CreatedAt: '',
      }
      let dt = DateTime.now().setZone('America/New_York');
      this.new_notification.CreatedAt = dt.toFormat('MMMM dd, yyyy');
    }
  }
}

